import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';

import HeroSection from './components/HeroSection';
import ExecutiveSummary from './components/ExecutiveSummary';
import MarketAnalysis from './components/MarketAnalysis';
import BusinessModel from './components/BusinessModel';
import FinancialProjections from './components/FinancialProjections';
import Strategy from './components/Strategy';
import TeamSection from './components/TeamSection';
import Timeline from './components/Timeline';
import ContactSection from './components/ContactSection';
import Navigation from './components/Navigation';
import { corporateTheme } from './themes/corporate';

const AppContainer = styled.div`
  background: ${corporateTheme.backgroundGradient};
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
  font-family: ${corporateTheme.fontFamily};
  color: ${corporateTheme.textPrimary};
`;

const Section = styled(motion.section)`
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0;
  
  @media (max-width: 768px) {
    min-height: 100vh;
    padding: 1rem 0;
  }
`;

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  return (
    <AppContainer>
      <Navigation />
      
      <Section id="hero">
        <HeroSection />
      </Section>
      
      <Section id="executive-summary">
        <ExecutiveSummary />
      </Section>
      
      <Section id="market-analysis">
        <MarketAnalysis />
      </Section>
      
      <Section id="business-model">
        <BusinessModel />
      </Section>
      
      <Section id="strategy">
        <Strategy />
      </Section>
      
      <Section id="financials">
        <FinancialProjections />
      </Section>
      
      <Section id="timeline">
        <Timeline />
      </Section>
      
      <Section id="team">
        <TeamSection />
      </Section>
      
      <Section id="contact">
        <ContactSection />
      </Section>
    </AppContainer>
  );
}

export default App; 